module.exports = __webpack_public_path__ + "48cb21fec6a503240b13d60f9d79c5f6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-witch.png
// module id = 2917
// module chunks = 0